module.exports = __webpack_public_path__ + "img/02.564944f5.png";